import { AskUserQuestionTool } from '#plugin-chat/components/tools/ask-user-question/AskUserQuestionTool.tsx';
import { DescribeViewsTool } from '#plugin-chat/components/tools/describe-views/DescribeViewsTool.tsx';
import { PlanTool } from '#plugin-chat/components/tools/plan/PlanTool.tsx';
import { QueryKnowledgeGraphTool } from '#plugin-chat/components/tools/query-knowledge-graph/QueryKnowledgeGraphTool.tsx';
import { ShowDashboardTool } from '#plugin-chat/components/tools/show-dashboard/ShowDashboardTool.tsx';
import { TransformDatasetTool } from '#plugin-chat/components/tools/transform-dataset/TransformDatasetTool.tsx';

/** Aggregated namespace of tool UI components for rendering LLM tool invocations in the chat interface. */
export const Tool = {
  AskUserQuestion: AskUserQuestionTool,
  DescribeViews: DescribeViewsTool,
  ShowDashboard: ShowDashboardTool,
  Plan: PlanTool,
  TransformDataset: TransformDatasetTool,
  QueryKnowledgeGraph: QueryKnowledgeGraphTool,
};
